import { render } from "./sellOutSetUp.vue?vue&type=template&id=1135f385"
import script from "./sellOutSetUp.vue?vue&type=script&lang=js"
export * from "./sellOutSetUp.vue?vue&type=script&lang=js"

import "./sellOutSetUp.vue?vue&type=style&index=0&id=1135f385&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__